export default {
  methods: {
    close() {
      this.$router.go(-1);
    },
  },
};



// WEBPACK FOOTER //
// ./src/mixins/ModalMixin.js